// ============================================================================
// Chloe Tween 保護者向け API クライアント（/tween/v1）
// ============================================================================
// 既存の api モジュール（Cognito Guardian ID Token 自動付与）を再利用する。
// server-spec §3 / §4。

import { api } from "./api";

export type TweenApprovalStatus = "blocked_pending" | "approved" | "denied";

export interface TweenDetection {
  eventId: string;
  source: string;
  category: string;
  categoryLabel: string;
  severity: "HIGH" | "MEDIUM" | "LOW";
  appPackage: string;
  occurredAt: string;
  meta: Record<string, unknown>;
  /** 課金・決済のみ: 承認ステータス（それ以外は null）。 */
  approvalStatus?: TweenApprovalStatus | null;
  decidedAt?: string | null;
}

export interface TweenDetectionsResponse {
  detections: TweenDetection[];
  nextCursor: string | null;
}

export interface TweenScreenTimeResponse {
  date: string;
  totalMinutes: number;
  byApp: Record<string, number>;
  byCategory: Record<string, number>;
}

export function fetchTweenDetections(
  deviceId: string,
  limit = 50,
  before?: string
): Promise<TweenDetectionsResponse> {
  return api.get<TweenDetectionsResponse>(
    `/tween/v1/children/${encodeURIComponent(deviceId)}/detections`,
    { query: { limit, before } }
  );
}

export function fetchTweenScreenTime(
  deviceId: string,
  date?: string
): Promise<TweenScreenTimeResponse> {
  return api.get<TweenScreenTimeResponse>(
    `/tween/v1/children/${encodeURIComponent(deviceId)}/screen-time`,
    { query: { date } }
  );
}

export interface TweenApprovalResult { eventId: string; approvalStatus: TweenApprovalStatus }

/** 課金・決済の遮断を承認/拒否する（保護者）。occurredAt は SK 特定に必要。 */
export function decideTweenApproval(
  deviceId: string,
  eventId: string,
  occurredAt: string,
  decision: "approve" | "deny"
): Promise<TweenApprovalResult> {
  return api.post<TweenApprovalResult>(
    `/tween/v1/children/${encodeURIComponent(deviceId)}/detections/${encodeURIComponent(eventId)}/approval`,
    { decision, occurredAt }
  );
}
